module.exports = __webpack_public_path__ + "img/arrow-login-left-alt.a3815703.svg";